import { lazy } from 'react';

import { Loadable } from '@trendiolive/trendio-selfcare-ui-kit';

import InitLayout from 'layout/Init';

const MerchantSelect = Loadable(lazy(() => import('pages/init/merchant-select')));

const InitRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <InitLayout />,
      children: [
        {
          path: 'merchant-select',
          element: <MerchantSelect />
        }
      ]
    }
  ]
};

export default InitRoutes;
